import React from 'react'
import { Link } from '@paypalcorp/pp-react'
// import data from "../../content/footer.en-XC.yaml"
import footerStyles from './Footer.module.css'

interface FooterProps {
  inverseHeaderScheme: boolean
}

const Footer: React.FC<FooterProps> = ({ inverseHeaderScheme }) => {
  const footerLinks = [
    { text: 'Reference', link: '/reference' },
    { text: 'PayPal.com', link: 'https://www.paypal.com/' },
    {
      text: 'Privacy',
      link: 'https://www.paypal.com/us/webapps/mpp/ua/privacy-full',
    },
    { text: 'Support', link: '/docs/support' },
    {
      text: 'Legal',
      link: 'https://www.paypal.com/webapps/mpp/ua/legalhub-full',
    },
    { text: 'Contact', link: 'https://www.paypal.com/us/smarthelp/contact-us' },
  ]
  const links = footerLinks.map((l, i) => (
    <Link
      key={`${l.text}-${i}`}
      secondary
      href={l.link}
      className={`${footerStyles.footerLinks} ${footerStyles.footerText}`}
    >
      {l.text}
    </Link>
  ))

  return (
    <div
      className={
        inverseHeaderScheme
          ? footerStyles.footerContainerWhite
          : footerStyles.footerContainer
      }
    >
      <div className={footerStyles.footerWrapper}>
        <div className={footerStyles.linkBtnContainer}>{links}</div>
      </div>
    </div>
  )
}

export default Footer
